'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CLOSED = exports.CLOSED = 'closed';
var CLOSING = exports.CLOSING = 'closing';
var CONNECTED = exports.CONNECTED = 'connected';
var CONNECTING = exports.CONNECTING = 'connecting';
var DISCONNECTED = exports.DISCONNECTED = 'disconnected';
var FAILED = exports.FAILED = 'failed';
var INITIALIZED = exports.INITIALIZED = 'initialized';
var SUSPENDED = exports.SUSPENDED = 'suspended';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/constants/connectionStates.js
// module id = 404
// module chunks = 2 3